import { Serializer } from 'survey-core';

export const registerCustomProperties = () => {
  Serializer.addProperty('page', {
    name: 'stepName',
    category: 'general',
    visibleIndex: 0
  });
  Serializer.addProperty('itemvalue', {
    name: 'tooltip:string'
  });
  Serializer.addProperty('itemvalue', {
    name: 'iconSrc:string'
  });
  Serializer.addProperty('itemvalue', {
    name: 'description:string'
  });
  Serializer.addProperty('page', {
    name: 'showCompleteButton:boolean',
    default: true
  });
};
